import { render } from "./PigsBatchesForm.vue?vue&type=template&id=291e420c&ts=true"
import script from "./PigsBatchesForm.vue?vue&type=script&lang=ts"
export * from "./PigsBatchesForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__